import { useQuery } from '@tanstack/react-query';
import { getTweet } from '../twitter.service';
export const useTweet = (id, options) => {
    return useQuery({
        queryKey: ['tweet', id],
        queryFn: () => getTweet(id),
        enabled: options?.enabled ?? !!id,
    });
};
